import type { SpriteDataInterface } from '@/map-phaser-new/interfaces'

export const mainObjectsSpriteLoadData: () => SpriteDataInterface[] = () => []
